<div class="page-shell">
  <header class="page-header">
    <div class="left">
      <button mat-button routerLink="/dashboard"><mat-icon>arrow_back</mat-icon> Dashboard</button>
      <div class="title-block">
        <p class="eyebrow">Parts</p>
        <h1>Parts Ordered</h1>
        <p class="subtitle">Track ordered parts and keep statuses in sync.</p>
      </div>
    </div>
    <div class="right">
      <button mat-raised-button color="primary" (click)="openDialog()">
        <mat-icon>add</mat-icon> New Parts Order
      </button>
    </div>
  </header>

  <div class="controls" *ngIf="!isLoading && orders.length > 0">
    <div class="status-cards">
      <button type="button" class="status-card focus" [class.active]="activeTab === 'ordered'" (click)="setTab('ordered')">
        <p class="label">Ordered</p>
        <div class="value">{{ orderedOrders.length }}</div>
        <p class="hint">Waiting to arrive</p>
      </button>
      <button type="button" class="status-card success" [class.active]="activeTab === 'received'" (click)="setTab('received')">
        <p class="label">Received</p>
        <div class="value">{{ receivedOrders.length }}</div>
        <p class="hint">Checked in</p>
      </button>
      <button type="button" class="status-card info" [class.active]="activeTab === 'shopping-list'" (click)="setTab('shopping-list')">
        <p class="label">Shopping List</p>
        <div class="value">{{ shoppingListOrders.length }}</div>
        <p class="hint">Items to purchase</p>
      </button>
    </div>
  </div>

  <div class="page-body card">
    <ng-container *ngIf="isLoading">
      <p class="state-text">Loading parts orders...</p>
    </ng-container>

    <ng-container *ngIf="!isLoading && orders.length === 0">
      <p class="state-text">No parts orders yet. Create one to start tracking incoming parts.</p>
    </ng-container>

    <ng-container *ngIf="!isLoading && orders.length > 0 && filteredOrders.length === 0">
      <p class="state-text">No {{ activeTab === 'shopping-list' ? 'shopping list items' : activeTab }} orders.</p>
    </ng-container>

    <table class="orders" *ngIf="!isLoading && filteredOrders.length > 0">
      <thead>
        <tr>
          <th>Order</th>
          <th>Supplier</th>
          <th>Status</th>
          <th>Expected / Received</th>
          <th>Qty</th>
          <th>Unit Cost</th>
          <th>Tracking</th>
          <th>Notes</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let order of filteredOrders">
          <td>
            <div class="primary link" (click)="openDialog(order)">{{ order.title }}</div>
            <div *ngIf="order.taskId; else noTask" class="muted link" (click)="openTask(order)">Task #{{ order.taskId }}</div>
            <ng-template #noTask><div class="muted">Task #—</div></ng-template>
          </td>
          <td>{{ order.supplier }}</td>
          <td>
            <span class="status" [ngClass]="order.status">{{ order.status || 'unknown' }}</span>
          </td>
          <td>
            <div *ngIf="order.expectedDate">ETA: {{ order.expectedDate | date:'mediumDate' }}</div>
            <div *ngIf="order.receivedDate">Received: {{ order.receivedDate | date:'mediumDate' }}</div>
          </td>
          <td>{{ order.quantity }}</td>
          <td *ngIf="order.unitCostCents !== undefined && order.unitCostCents !== null">${{ (order.unitCostCents/100) | number:'1.2-2' }}</td>
          <td *ngIf="order.unitCostCents === undefined || order.unitCostCents === null"></td>
          <td>{{ order.trackingNumber }}</td>
          <td>{{ order.notes }}</td>
          <td class="actions">
            <button mat-stroked-button color="primary" (click)="toggleReceived(order)">
              {{ order.status === 'received' ? 'Received' : 'Mark as received' }}
            </button>
            <button mat-button (click)="openDialog(order)">Edit</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

